import styled from 'styled-components';
import { CustomThemeToken } from '@/theme';

interface FooterContainerProps {
  theme: { token: CustomThemeToken };
}

export const FooterContainer = styled.div<FooterContainerProps>`
  .horizontal-border {
    height: 1px;
    width: 100%;
  }
    
  .bottom-row {
    display: flex;
    align-items: center;
    align-self: stretch;
    border-top: 1px solid ${({ theme: { token } }) => token.colorBorderSecondary};
    ${({ theme: { token } }) => token.borderRadiusLG}px;
    min-height: ${({ theme: { token } }) => token.paddingXL * 2}px;

    .bottom-left-container {
      display: flex;
      justify-content: flex-start;
      flex-grow: 1;
      margin-bottom: ${({ theme: { token } }) => token.marginXXS}px;
      margin-top: ${({ theme: { token } }) => token.marginXS}px;

      .flex-row-centered {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: ${({ theme: { token } }) => token.marginXXS}px;
      }

      .flex-column-centered {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
      }
    }

    .lower-right-border {
      width: 1px;
      background-color: ${({ theme: { token } }) => token.colorBorderSecondary};
      z-index: 1;
      align-self: stretch;
      margin-right: ${({ theme: { token } }) => token.paddingXS}px;
    }
  }

  .start-stop-buttons-container {
      .flex-row-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: ${({ theme: { token } }) => token.paddingXS}px;
        gap: ${({ theme: { token } }) => token.marginXS}px;

        button {
          > * {
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

  .bottom-padding {
    padding: 0 ${({ theme: { token } }) => token.marginXS}px;
  }
`;
